import api from "./api";

const talpoolService = {
    get_live_alerts(payload) {
      return api.post(`hse/get_live_alerts`, payload);
    },
    get_cameras(payload) {
      return api.put(`asset/get_cameras`, payload);
    },
    check_cameras_status(payload) {
      return api.put(`asset/check_cameras_status`, payload);
    },
    get_stats(payload) {
      return api.put(`hse/get_stats`, payload);
    },
    get_alert_trend(payload) {
      return api.put(`hse/get_alert_trend`, payload);
    },
   
    
  
  };
  
  export default talpoolService;